import { StatisticsQueries } from "queries/stat-queries";

export interface Statistics {
    total_revenue: number | null;
    total_products_sold_count: number; // number of products sold
    growth_rate: number; // convert to percentage
    total_orders: number;
    total_30_day_revenue: number; // last 30 days revenue
    revenue_chart: RevenueChart[];
    product_stats: ProductStats[];
    visitors_chart: VisitorsChart[];
    conversion_rate: number;
    average_order_value: number;
}

export interface ProductStats {
    name: string;
    price: number;
    category: string;
    image_url: string;
    count: number; // number of times product has sold
}

interface RevenueChart {
    date: string;
    revenue: number;
}

interface VisitorsChart {
    date: string;
    visits: number;
}

export async function getStatisticsAction() {
    try {
        const response = await StatisticsQueries.getAllStats();
        const data: Statistics = await response.json();

        // console.log(data);

        return {data, status: response.status};
    } catch (err) {
        // console.log(err);
        return null; // Optionally return null or handle the error accordingly
    }
}
